<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="show-renewal-percentage-breakdown-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Renewal Percentage Breakdown ({{ formattedMonth }})
                        </h4>
                    </div>

                    <loading-spinner v-if="loading"></loading-spinner>

                    <div v-else class="modal-body">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="col-xs-6">
                                    Subscriber
                                </th>

                                <th class="col-xs-3">
                                    Portal
                                </th>

                                <th class="col-xs-3">
                                    Renewed
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="subscriptionPeriod in subscriptionPeriods.data">
                                <td class="table__ellipsis">
                                    <router-link
                                            :to="'/' + subscriptionPeriod.subscription.subscriber_type + '/' + subscriptionPeriod.subscription.subscriber_id + '/subscriptions/' + subscriptionPeriod.subscription.id"
                                            @click.native="hide"
                                    >
                                        {{ subscriptionPeriod.subscription.subscriber.name }}
                                    </router-link>
                                </td>

                                <td class="table__ellipsis">
                                    <router-link :to="'/portals/' + subscriptionPeriod.subscription.portal.id"
                                                 @click.native="hide">
                                        {{ subscriptionPeriod.subscription.portal.name }}
                                    </router-link>
                                </td>

                                <td>
                                    <span v-if="!subscriptionPeriod.is_last" class="label label-success">
                                        Yes
                                    </span>

                                    <span v-else-if="subscriptionPeriod.subscription.has_automatic_renewal"
                                          class="label label-warning">
                                        Automatic
                                    </span>

                                    <span v-else class="label label-danger">
                                        No
                                    </span>
                                </td>
                            </tr>
                            </tbody>

                            <tfoot>
                            <tr>
                                <td colspan="2" class="text-right">
                                    <b>
                                        Total
                                    </b>
                                </td>

                                <td>
                                    <b>
                                        {{ renewed }}/{{ ending }} = {{ renewedPercentage }} %
                                    </b>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                        <resource-pager :pagination="subscriptionPeriods.meta" @navigate="navigate"/>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'
    import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'

    export default {
        components: {ResourcePager, LoadingSpinner},

        props: {
            month: {
                required: true
            },

            filters: {
                required: true
            }
        },

        data() {
            return {
                subscriptionPeriods: null,
                renewed: null,
                ending: null,

                page: 1,

                loading: true
            }
        },

        mounted() {
            this.listenForClose()

            this.load()
        },

        watch: {
            month() {
                this.load()
            }
        },

        computed: {
            formattedMonth() {
                return moment(this.month).format('YYYY-MM')
            },

            requestFilters() {
                let filters = {}

                if (this.filters.find(filter => filter.dimension === 'portal_id')) {
                    filters.portal_id = this.filters.find(filter => filter.dimension === 'portal_id').value
                }

                if (this.filters.find(filter => filter.dimension === 'subscriber_type')) {
                    filters.subscriber_type = this.filters.find(filter => filter.dimension === 'subscriber_type').value
                }

                return filters
            },

            renewedPercentage() {
                return Math.round(this.renewed / this.ending * 100)
            }
        },

        methods: {
            load() {
                this.loading = true

                Promise.all(this.getTotalPromises().concat([this.getListPromise()]))
                    .then(responses => {
                        this.renewed = responses[0].data.data[0].ending_subscription_count

                        this.ending = responses[1].data.data[0].ending_subscription_count

                        this.subscriptionPeriods = responses[2].data

                        this.loading = false
                    })
            },

            loadPage() {
                this.loading = true

                this.getListPromise().then(response => {
                    this.subscriptionPeriods = response.data

                    this.loading = false
                })
            },

            getListPromise() {
                return http.get('/api/v1/subscription-periods', {
                    'filter[ends_from]': this.month,
                    'filter[ends_to]': moment(this.month).endOf('month').format('YYYY-MM-DD'),
                    page_size: 10,
                    page: this.page,
                    ...this.requestFilters
                })
            },

            getTotalPromises() {
                return [
                    http.post('/api/v1/reports/dashboard', {
                        start: this.month,
                        end: moment(this.month).endOf('month').format('YYYY-MM-DD'),
                        metrics: ['ending_subscription_count'],
                        filters: this.filters.concat([{dimension: 'is_last_subscription_period', value: false}])
                    }),
                    http.post('/api/v1/reports/dashboard', {
                        start: this.month,
                        end: moment(this.month).endOf('month').format('YYYY-MM-DD'),
                        metrics: ['ending_subscription_count'],
                        filters: this.filters
                    })
                ]
            },

            hide() {
                $(this.$el).modal('hide')
            },

            navigate(page) {
                this.page = page

                this.loadPage()
            },

            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            reset() {
                this.page = 1
            }
        }
    }
</script>
